import { Controller } from '@hotwired/stimulus';

import phoner from '@/modules/phoner';
import Zipcoder from '@/modules/zipcoder';

export default class extends Controller {
  connect() {
    phoner();

    new Zipcoder({ scope: 'personal' }).create();
  }
}
